/**
 * AdBanner Component
 * 
 * Displays Google AdSense banner ads
 * Responsive design that works on all devices
 */

import React, { useEffect } from "react";

interface AdBannerProps {
  /** Ad unit ID from Google AdSense */
  adSlot: string;
  /** Ad format - responsive, rectangle, etc. */
  format?: string;
  /** Ad size - auto, 728x90, 300x250, etc. */
  // size?: string; // Unused prop
  /** CSS class for styling */
  className?: string;
}

export const AdBanner: React.FC<AdBannerProps> = ({ 
  adSlot, 
  format = "auto", 
  className = ""
}) => {
  useEffect(() => {
    try {
      // Only initialize AdSense if consent was granted
      const consent = typeof window !== 'undefined' ? localStorage.getItem('adConsent') : null;
      if (consent !== 'granted') return;

      if (typeof window !== 'undefined' && (window as any).adsbygoogle) {
        ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      }
    } catch (error) {
      console.log("AdSense not available:", error);
    }
  }, []);

  // Hide the placeholder if consent not granted
  const consentGranted = typeof window !== 'undefined' ? localStorage.getItem('adConsent') === 'granted' : false;
  if (!consentGranted) return null;

  return (
    <div className={`ad-container ${className}`}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-4458181362254170"
        data-ad-slot={adSlot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};
